import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=4778a168&scoped=true&"
import script from "./QuickUser.vue?vue&type=script&lang=js&"
export * from "./QuickUser.vue?vue&type=script&lang=js&"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=4778a168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778a168",
  null
  
)

export default component.exports